export default __webpack_public_path__ + "static/media/hermes-luxury-btn.b52ce5e7.png";